import { ChevronLeft, ChevronRight, MousePointer2 } from "lucide-react";
import type { ParsedPdf } from "../types";
import { tokenizePage } from "../lib/text";
import { PdfCanvas } from "./PdfCanvas";

type PdfReaderProps = {
  file: File;
  parsed: ParsedPdf;
  pageNumber: number;
  selectedWord: string;
  onPageChange: (page: number) => void;
  onWordSelect: (word: string, context: string) => void;
};

export function PdfReader({
  file,
  parsed,
  pageNumber,
  selectedWord,
  onPageChange,
  onWordSelect,
}: PdfReaderProps) {
  const page = parsed.pages[pageNumber - 1];
  const tokens = tokenizePage(page?.text ?? "");

  return (
    <section className="reader-card">
      <div className="reader-toolbar">
        <div>
          <span className="status-dot" />
          <strong>{parsed.name}</strong>
          <span className="muted">
            {parsed.pageCount} {parsed.format === "epub" ? "bölüm" : "sayfa"}
          </span>
        </div>
        <div className="pager">
          <button
            className="icon-button"
            disabled={pageNumber <= 1}
            onClick={() => onPageChange(pageNumber - 1)}
            aria-label="Önceki sayfa"
          >
            <ChevronLeft size={19} />
          </button>
          <span>{pageNumber} / {parsed.pageCount}</span>
          <button
            className="icon-button"
            disabled={pageNumber >= parsed.pageCount}
            onClick={() => onPageChange(pageNumber + 1)}
            aria-label="Sonraki sayfa"
          >
            <ChevronRight size={19} />
          </button>
        </div>
      </div>

      <div className="reader-grid">
        {parsed.format === "pdf" && (
          <div className="pdf-preview">
            <PdfCanvas file={file} pageNumber={pageNumber} />
          </div>
        )}

        <div className={`text-reading-panel ${parsed.format === "epub" ? "is-epub" : ""}`}>
          <div className="text-panel-heading">
            <MousePointer2 size={17} />
            <span>Bir kelimeye dokun</span>
          </div>
          <article
            className="clickable-text"
            aria-label={`${parsed.format === "epub" ? "Bölüm" : "Sayfa"} ${pageNumber} metni`}
          >
            {tokens.map((token) =>
              token.isWord ? (
                <button
                  key={token.key}
                  className={
                    token.text.toLocaleLowerCase() === selectedWord.toLocaleLowerCase()
                      ? "word-token is-selected"
                      : "word-token"
                  }
                  onClick={() => onWordSelect(token.text, token.context)}
                >
                  {token.text}
                </button>
              ) : (
                <span key={token.key}>{token.text}</span>
              ),
            )}
          </article>
        </div>
      </div>
    </section>
  );
}
